<img
  id="logo"
  src="assets/img/ogi-logo.png"
  alt="ogibiotec"
/>
<div id="page">
  <div id="container">
    @if (tokenStatus() === TokenStatusEnum.Valid && !accountCreated()) {
      <div id="form--container">
        <h4>Nearly there</h4>
        <p>Please enter a password to finish setting up your account.</p>
        @if (createUserError()?.message) {
          <div class="error" role="alert" aria-live="assertive">
            <span>Error: </span>
            {{ createUserError()?.message }}
          </div>
        }
        <form [formGroup]="createUserForm" (ngSubmit)="onSubmit()">
          <app-mat-form-field
            iconName="lock"
            [field]="passwordField"
            [parentForm]="createUserForm"
          ></app-mat-form-field>
          <app-mat-form-field
            iconName="lock"
            [field]="confirmPasswordField"
            [parentForm]="createUserForm"
          >
          </app-mat-form-field>
          <ul class="body2">
            <app-validation-row
              validationText="Password must be at least 12 characters long"
              [passesValidation]="passesValidation('length')"
            ></app-validation-row>
            <app-validation-row
              validationText="Password must contain at least one uppercase letter"
              [passesValidation]="passesValidation('uppercaseLetter')"
            ></app-validation-row>
            <app-validation-row
              validationText="Password must contain at least one lowercase letter"
              [passesValidation]="passesValidation('lowercaseLetter')"
            ></app-validation-row>
            <app-validation-row
              validationText="Password must contain at least one number"
              [passesValidation]="passesValidation('number')"
            ></app-validation-row>
            <app-validation-row
              validationText="Password must contain at least one special character (@#$%^&+!=)"
              [passesValidation]="passesValidation('specialCharacter')"
            ></app-validation-row>
          </ul>
          <div>
            <div class="link">
              <app-checkbox
                [checkbox]="eula"
                [parentForm]="createUserForm"
              ></app-checkbox>
              <p>
                I accept the terms in the
                <a
                  href="https://ogibiotec.com/end-user-license/"
                  target="_blank"
                  rel="noopener noreferrer"
                  >End User Licence Agreement</a
                >
              </p>
            </div>
            <div class="link">
              <app-checkbox
                [checkbox]="termsAndConditions"
                [parentForm]="createUserForm"
              ></app-checkbox>
              <p>
                I accept the
                <a
                  href="https://ogibiotec.com/terms-and-conditions/"
                  target="_blank"
                  rel="noopener noreferrer"
                  >Terms & Conditions</a
                >
                and
                <a
                  href="https://ogibiotec.com/privacy-policy/"
                  target="_blank"
                  rel="noopener noreferrer"
                  >Privacy Policy</a
                >
              </p>
            </div>
          </div>
          <app-button
            buttonType="submit"
            label="Create Account"
            buttonId="create-acc-btn"
            [isDisabled]="createUserForm.invalid"
            [isProcessing]="isProcessing()"
          ></app-button>
        </form>
      </div>
    }
    @if (tokenStatus() === TokenStatusEnum.Valid && accountCreated()) {
      <div id="form--container">
        <mat-icon>check_circle</mat-icon>
        <h4>Please Confirm Email</h4>
        <div>A verification link has been sent to your email address. Please click the link in that email to confirm your email address.</div>
      </div>
    }
    @if (tokenStatus() === TokenStatusEnum.Validating) {
      <app-loading-spinner label="Verifying invitation…"></app-loading-spinner>
    }
    @if (tokenStatus() === TokenStatusEnum.Invalid) {
      <div id="validation--error">
        <mat-icon class="red-icon">error</mat-icon>
        <h4>Something went wrong</h4>
        @if (validationError()?.message) {
          <div class="error" role="alert" aria-live="assertive">
            <span>Error: </span>{{ validationError()?.message  }}
          </div>
        }
      </div>
    }
  </div>
</div>
